import { render, staticRenderFns } from "./books.vue?vue&type=template&id=b084de46&scoped=true&"
import script from "./books.vue?vue&type=script&lang=js&"
export * from "./books.vue?vue&type=script&lang=js&"
import style0 from "./books.vue?vue&type=style&index=0&id=b084de46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b084de46",
  null
  
)

export default component.exports